export default "__VITE_ASSET__ClAAKdB4__"